import { render, staticRenderFns } from "./StarterPackInfoCards.vue?vue&type=template&id=1d98406a&scoped=true"
import script from "./StarterPackInfoCards.vue?vue&type=script&lang=js"
export * from "./StarterPackInfoCards.vue?vue&type=script&lang=js"
import style0 from "./StarterPackInfoCards.vue?vue&type=style&index=0&id=1d98406a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98406a",
  null
  
)

export default component.exports